export interface ParteTextoComLink {
  texto: string;
  url?: string;
}

export function separarLinks(texto: string): ParteTextoComLink[] {
  const partes: ParteTextoComLink[] = [];
  const regex = /(?:https?:\/\/|www\.)[^\s<>"']+/gi;
  let inicio = 0;
  let match: RegExpExecArray | null;
  while ((match = regex.exec(texto)) !== null) {
    if (match.index > 0 && /[\w@]/.test(texto[match.index - 1])) continue;
    let link = match[0].replace(/[.,!?;:]+$/, '');
    const pares: Record<string, string> = { ')': '(', ']': '[', '}': '{' };
    while (pares[link.slice(-1)]) {
      const fechamento = link.slice(-1), abertura = pares[fechamento];
      if (link.split(fechamento).length <= link.split(abertura).length) break;
      link = link.slice(0, -1).replace(/[.,!?;:]+$/, '');
    }
    const url = /^www\./i.test(link) ? 'https://' + link : link;
    try {
      const parsed = new URL(url);
      if (!parsed.hostname || !['http:', 'https:'].includes(parsed.protocol)) continue;
    } catch { continue; }
    if (match.index > inicio) partes.push({ texto: texto.slice(inicio, match.index) });
    partes.push({ texto: link, url });
    inicio = match.index + link.length;
  }
  if (inicio < texto.length) partes.push({ texto: texto.slice(inicio) });
  return partes;
}
